import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-reward-slider',
  templateUrl: './reward-slider.component.html',
  styleUrls: ['./reward-slider.component.scss'],
})
export class RewardSliderComponent {

  @Input('displayOnly') hideKnob: boolean = true;
  @Input('sliderValue') sliderValue = 0;
  @Output() sliderOnChange: EventEmitter<any> = new EventEmitter();
  public rangeValue: number = 0;

  constructor() { }

  ngOnChanges() {
    this.setValue(this.sliderValue);
  }

  rangeOnChange(event) {
    this.sliderOnChange.emit(this.rangeValue);
  }

  private setValue(value: number) {
    this.rangeValue = value;
  }
}
